import * as React from 'react';
//import { AppProps } from '../../components/app';
import PackageListingContainer from '../../components/package-listing-container';
import CartContainer from '../../components/cart/container';
import QuantitySelect from '../../components/cart/quantity-select';

import FiltersContainer from '../../components/filters/container';
import { AppProps } from '../../components/app';

// Resize Sensor will ensure the sticky sidebar is able to update itself when the content changes
import 'css-element-queries/src/ResizeSensor.js';
import StickySidebar from 'sticky-sidebar';

interface FixedState {
    stickyInstance: any;
}

class AppView extends React.Component<AppProps, FixedState> {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <>

                {
                    this.props.settings.isRenewal ? null
                        :
                        <nav className="ace-filters-container space-top-lg stack-sm">
                            <div className="ace-block-inner">
                                <h2 className="ace-subs-filter-heading">{this.props.text.filtersTitle}</h2>
                            </div>
                            <FiltersContainer />
                        </nav>
                }

                <div className="ace-page-section">
                    <section className={`${!this.props.settings.useUnseatedReservation ? "" : "ace-layout ace-layout-8-4"}`}>
                        <div className="ace-subs-listing">
                            <PackageListingContainer />
                        </div>
                        {
                            !this.props.settings.useUnseatedReservation ? null :
                                <div className="ace-subs-sidebar" id="miniCart">
                                    <CartContainer />
                                </div>
                        }
                    </section>
                </div>
            </>
        );
    }
}

export default AppView;